export const BG_COLOR = "rgb(120, 0, 20)"
export const FG_COLOR = "rgb(200, 165, 147)"
